import { IDate } from "../../components/Table/hooks/useDateFilter";
import { LoadState } from "../../constants/enums";

export interface ICommonState {
  policies: {
    list: IPolicies[];
    loadState: LoadState;
  };
  generalHistory: {
    data: IGeneralHistoryResponse | null;
    list: IGeneralHistory[];
    loading: LoadState;
  };
  recordCounts: {
    list: IRecordCount[];
    loading: LoadState;
  };
  whatsappCounts: {
    list: IWhatsappCount[];
    loading: LoadState;
  };
  paymentTransactionCounts: {
    list: IRecordCount[];
    loading: LoadState;
  };
  modules: {
    tableNames: {
      data: string[];
      loading: LoadState;
    };
    tableViews: {
      data: string[];
      loading: LoadState;
    };
  };
  endPointsByModule: {
    data: {
      [key: string]: string[];
    };
    loading: LoadState;
  };
}

export interface IRecordCount {
  status: string;
  count: number;
}

export interface IWhatsappCount {
  status: string;
  cnt: number;
}

export interface IPolicies {
  type: string;
  subTypes: {
    policy_id: number;
    name: string;
  }[];
}

export interface IGeneralHistory {
  insert_ts: string;
  [key: string]: any;
}

export interface IGeneralHistoryResponse {
  leads_uuid?: string;
  name_of_guest?: string;
  contact_number_one?: string;
  contact_number?: string;
  function_date?: string | null;
  date_of_visit?: string;
  event_type?: string;
  followup_date?: string;
  handled_by_employee?: string;
  number_of_guests?: number;
  number_of_rooms?: number;
  preferred_venue?: string | null;
  status?: string;
  derived_status?: string;
  customer_code?: string;
  customer_name?: string;
  first_name?: string;
  goes_by?: string;
  remarks?: string;
  function_month?: string;
  created_by_name?: string;
  company_outlet_name?: string;
  result: IGeneralHistory[];
}

export const defaultCommonState: ICommonState = {
  policies: {
    list: [],
    loadState: LoadState.NotLoaded,
  },
  generalHistory: {
    data: null,
    list: [],
    loading: LoadState.NotLoaded,
  },
  recordCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  whatsappCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  paymentTransactionCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  modules: {
    tableNames: {
      data: [],
      loading: LoadState.NotLoaded,
    },
    tableViews: {
      data: [],
      loading: LoadState.NotLoaded,
    },
  },
  endPointsByModule: {
    data: {},
    loading: LoadState.NotLoaded,
  },
};

export interface IMail {
  from_email: string | null;
  from_name: string | null;
  emails: string[];
  subject: string;
  body: string;
  templateName: string | null;
  templateId: string | null;
  objectVariables: any;
  cc: string[];
  bcc: string[];
  reply_to?: {
    email: string;
    name: string;
  };
  attachments?: {
    content: string;
    filename: string;
  }[];
  history?: {
    module_name: string;
    module_code: string;
  };
}

export interface IQueryParams {
  page: number;
  rowsPerPage: number;
  status: string;
  columns: string[];
  value: string;
  fromDate?: string;
  toDate?: string;
  company_outlet_uuid?: string;
}

export interface IMail {
  // from_email: string | null;
  // from_name: string | null;
  emails: string[];
  subject: string;
  body: string;
  templateName: string | null;
  objectVariables: any;
  cc: string[];
  bcc: string[];
  reply_to?: {
    email: string;
    name: string;
  };
  attachments?: {
    content: string;
    filename: string;
  }[];
  history?: {
    module_name: string;
    module_code: string;
  };
}

export interface IEventTime {
  event_timing_id: number;
  event_timing_uuid: string;
  event_name: string;
  description: string;
  status: string;
  created_by_uuid: string | null;
  created_by_name: string | null;
  modified_by_uuid: string | null;
  modified_by_name: string | null;
  create_ts: string; // ISO date string
  insert_ts: string; // ISO date string
}
export interface ISession {
  session_info_id: number;
  session_info_unique_id: number;
  session_info_uuid: string;
  session_name: string;
  session_duration_in_years: string;
  session_starting_date: string; // ISO date string
  session_ending_date: string; // ISO date string
  status: string; // e.g., "ACTIVE"
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string; // ISO date string
  insert_ts: string; // ISO date string
}

export interface IOrganization {
  organizations_id: number;
  organizations_unique_id: number;
  organizations_uuid: string;
  organizations_name: string;
  status: string;
  created_by_uuid?: string;
  created_by_name?: string;
  modified_by_uuid?: string;
  modified_by_name?: string;
  create_ts?: string | null;
  insert_ts?: string;
}

export interface ISearchQueryParams {
  status?: string;
  page: number;
  rowsPerPage: number;
  limit: number;
  columns?: string[];
  value?: string;
  date?: IDate;
  advancedFilters?: IDatatableV2AdvancedSearchFilter;
}

export interface IDataTableV2SearchFilterSearchItem {
  column: string[];
  operator: string;
  value: string;
  logicalOperator: "AND" | "OR";
}

export type IDatatableV2AdvancedSearchFilter =
  IDataTableV2SearchFilterSearchItem[];
